import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckIcon, AcademicCapIcon } from "@heroicons/react/24/solid";
import cardBackground from "../images/card-background.png";

function LessonCard({ lesson, isCompleted = false, returnPath = "/lessons" }) {
  const navigate = useNavigate();

  return (
    <div
      className="w-full bg-white rounded-lg overflow-hidden hover:border-gray-400 transition-colors duration-300 cursor-pointer relative h-full flex flex-col"
      onClick={() =>
        navigate(`/lesson/${lesson.id}`, { state: { returnPath } })
      }
    >
      {/* Top section - Cover image */}
      <div className="h-64 bg-gray-200 flex items-center justify-center overflow-hidden relative">
        {/* Lesson type pill indicator */}
        <div className="absolute bottom-3 right-3 z-10 group">
          <div className="w-8 h-8 bg-primary-500 rounded-full flex items-center justify-center shadow-lg">
            <AcademicCapIcon className="w-5 h-5 text-white" />
          </div>
          {/* Tooltip */}
          <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-primary-500 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
            Lesson
            <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-2 border-r-2 border-t-2 border-transparent border-t-primary-500"></div>
          </div>
        </div>

        {/* Completion indicator */}
        {isCompleted && (
          <div className="absolute top-3 left-3 z-10">
            <div className="w-10 h-10 bg-primary-500 rounded-full flex items-center justify-center shadow-lg">
              <CheckIcon className="w-7 h-7 text-white" />
            </div>
          </div>
        )}
        {lesson.cover_image ? (
          <img
            src={lesson.cover_image}
            alt={lesson.title || "Lesson cover"}
            className="w-full h-full object-cover absolute inset-0"
            onError={(e) => {
              // Fallback to placeholder if image fails to load
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "flex";
            }}
          />
        ) : null}

        {/* Placeholder (shown if no cover_image or if image fails to load) */}
        <div
          className={`text-gray-500 text-center ${
            lesson.cover_image ? "hidden" : "flex"
          } items-center justify-center w-full h-full`}
        >
          <div>
            <svg
              className="w-16 h-16 mx-auto mb-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
                clipRule="evenodd"
              />
            </svg>
            <p className="text-sm">Image</p>
          </div>
        </div>
      </div>

      {/* Bottom section - Text with background image */}
      <div
        className="p-5 pt-3 pb-2 rounded-b-lg flex-1 flex flex-col"
        style={{
          backgroundImage: `url(${cardBackground})`,
          backgroundRepeat: "repeat",
          backgroundSize: "auto",
        }}
      >
        <h3 className="text-xl font-bold text-gray-900 mb-1">
          {lesson.title || "No title"}
        </h3>
        <div className="flex-1 flex flex-col flex-start">
          <div className="border-b border-gray-300 mt-2 mb-2"></div>
          <p className="text-sm text-gray-600 font-light tracking-wide uppercase mb-1">
            {lesson.units && Array.isArray(lesson.units)
              ? lesson.units.join(", ")
              : "No units specified"}
          </p>
        </div>
      </div>
    </div>
  );
}

export default LessonCard;
